import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';

import React from 'react';
import { useDispatch } from 'react-redux';
import { REMOTE_ASESETUP_CLOSED } from 'store/actions';

import { FoldersListScreen } from './FoldersListScreen';
import { SectionListScreen } from './SectionListScreen';

const Stack =
  createNativeStackNavigator<
    NavigationStacks[Stacks.ASSESSMENTSETUPLIBRARYEXPLORER]
  >();

export const AssessmentSetupLibraryScreen: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(REMOTE_ASESETUP_CLOSED());
    };
  }, [dispatch]);

  return (
    <Stack.Navigator
      initialRouteName={Screens.ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS}
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name={Screens.ASSESSMENTSETUPLIBRARYEXPLORERFOLDERS}
        component={FoldersListScreen}
      />
      <Stack.Screen
        name={Screens.ASSESSMENTSETUPLIBRARYEXPLORERSECTIONS}
        component={SectionListScreen}
      />
    </Stack.Navigator>
  );
};
